import { useTranslation } from 'next-i18next';
import React, { useEffect } from 'react';
import { useState } from 'react';
import Episode from '../Episode/Episode';

type Props = {
  selectedSeason?: number;
  seasons: any;
};

const SeasonsList: React.FC<Props> = ({ selectedSeason, seasons }: Props) => {
  console.log(seasons);
  const { t } = useTranslation();
  const [season, setSeason] = useState({ episodes: [], season_number: 1 });

  useEffect(() => {
    if (seasons.length > 0) {
      if (selectedSeason) {
        setSeason(
          seasons.find((item) => item.season_number === selectedSeason),
        );
      } else {
        setSeason(seasons[0]);
      }
    }
  }, []);

  const handleChangeSeason = (event) => {
    const value = parseInt(event.target.value);
    setSeason(seasons.find((item) => item.season_number === value));
  };

  return (
    <div className="w-full pt-4">
      <div className="flex flex-col md:flex-row justify-between">
        <span className="order-2 md:order-1 text-2xl font-semibold pl-2 mt-12 mb-4 md:my-0">
          {season.episodes.length} {t('episodes')}
        </span>
        <select
          className="order-1 w-full md:w-44 text-sm cursor-pointer"
          onChange={handleChangeSeason}
          defaultValue={season.season_number}
        >
          {seasons.map((season) => (
            <option key={season.season_number} value={season.season_number}>
              {`${t('season')} ${season.season_number}`}
            </option>
          ))}
        </select>
      </div>
      <div className="mt-4 divide-y divide-white divide-opacity-10">
        {season.episodes.map((episode) => (
          <Episode key={episode._id} season={season} episode={episode} />
        ))}
      </div>
    </div>
  );
};

export default SeasonsList;
